import { render, staticRenderFns } from "./policyDocument.vue?vue&type=template&id=5cbeac4c&scoped=true&"
import script from "./policyDocument.vue?vue&type=script&lang=js&"
export * from "./policyDocument.vue?vue&type=script&lang=js&"
import style0 from "./policyDocument.vue?vue&type=style&index=0&id=5cbeac4c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cbeac4c",
  null
  
)

export default component.exports